import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag",
  "use": "icon-tag-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-tag\">\n  <path fill=\"currentColor\" d=\"M10.078 4.013l-5.582 5.57a1.686 1.686 0 000 2.388l3.529 3.521a1.695 1.695 0 002.393 0L16 9.923v-5.91h-5.922zm3.148 3.69a.92.92 0 110-1.84.92.92 0 010 1.84z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol